import React from "react";
import { FilterQuickKeyFormContext } from "./context";

export const useFilterQuickKeyFormContext = () => {
  const context = React.useContext(FilterQuickKeyFormContext);
  if (context === undefined) {
    throw new Error(
      "useFilterQuickKeyFormContext must be used within a FilterQuickKeyFormProvider"
    );
  }
  return context;
};
